"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createSvg = require("../createSvg");
var _interfaces = require("../interfaces");
var _SVGIconWithSizes;
var _default = (0, _createSvg.createSvg)('IconAccessibilityPersonCircle', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 0.999999 8 1C11.866 1 15 4.13401 15 8ZM13 6C13 5.44772 12.5523 5 12 5L4 5C3.44772 5 3 5.44772 3 6C3 6.55229 3.44772 7 4 7L5.5 7L5.5 13C5.5 13.5523 5.94772 14 6.5 14C7.05228 14 7.5 13.5523 7.5 13V10L8.5 10V13C8.5 13.5523 8.94772 14 9.5 14C10.0523 14 10.5 13.5523 10.5 13V7L12 7C12.5523 7 13 6.55228 13 6ZM9.5 3C9.5 3.82843 8.82843 4.5 8 4.5C7.17157 4.5 6.5 3.82843 6.5 3C6.5 2.17157 7.17157 1.5 8 1.5C8.82843 1.5 9.5 2.17157 9.5 3Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 0.999999 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10ZM4 6.00003C3.44771 6.00003 3 6.44774 3 7.00003C3 7.55232 3.44771 8.00003 4 8.00003H7L7 17C7 17.5523 7.44771 18 8 18C8.55228 18 9 17.5523 9 17L9 13L11 13V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V8.00003L16 8.00003C16.5523 8.00003 17 7.55232 17 7.00003C17 6.44775 16.5523 6.00003 16 6.00003H4ZM11.75 3.75C11.75 4.7165 10.9665 5.5 10 5.5C9.0335 5.5 8.25 4.7165 8.25 3.75C8.25 2.7835 9.0335 2 10 2C10.9665 2 11.75 2.7835 11.75 3.75Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 0.999999 12 1C18.0751 0.999999 23 5.92487 23 12ZM4.00003 9C4.00003 8.44771 4.44775 8 5.00003 8H19C19.5523 8 20 8.44772 20 9C20 9.55228 19.5523 10 19 10H15V21C15 21.5523 14.5523 22 14 22C13.4477 22 13 21.5523 13 21L13 15L11 15V21C11 21.5523 10.5523 22 10 22C9.44775 22 9.00003 21.5523 9.00003 21L9.00002 10L5.00003 10C4.44775 10 4.00003 9.55228 4.00003 9ZM14 4.5C14 5.60457 13.1046 6.5 12 6.5C10.8954 6.5 10 5.60457 10 4.5C10 3.39543 10.8954 2.5 12 2.5C13.1046 2.5 14 3.39543 14 4.5Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M31 16C31 24.2843 24.2843 31 16 31C7.71573 31 1 24.2843 1 16C1 7.71573 7.71573 0.999999 16 1C24.2843 0.999999 31 7.71573 31 16ZM27 11.5C27 10.6716 26.3284 10 25.5 10L6.5 10C5.67158 10 5 10.6716 5 11.5C5 12.3284 5.67157 13 6.5 13L12 13L12 27.5C12 28.3284 12.6716 29 13.5 29C14.3284 29 15 28.3284 15 27.5L15 21L17 21L17 27.5C17 28.3284 17.6716 29 18.5 29C19.3284 29 20 28.3284 20 27.5V13L25.5 13C26.3284 13 27 12.3284 27 11.5ZM19 6C19 7.65685 17.6569 9 16 9C14.3431 9 13 7.65685 13 6C13 4.34314 14.3431 3 16 3C17.6569 3 19 4.34314 19 6Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));
exports.default = _default;